const constants = {
    SET_LOADER: "SET_LOADER",
    SET_CHATS_LOADER: "SET_CHATS_LOADER",
    SET_AUTH: "SET_AUTH",
    SET_AGENT: "SET_AGENT",
    SET_CHATS: "SET_CHATS",
    SET_CHATS_LIST_FILTERS: "SET_CHATS_LIST_FILTERS",
    UPDATE_CHAT: "UPDATE_CHAT",
    UPDATE_CHAT_SEEN: "UPDATE_CHAT_SEEN",
    ADD_OR_UPDATE_CHAT: "ADD_OR_UPDATE_CHAT",
    SET_SELECTED_CHAT: "SET_SELECTED_CHAT",
    SET_SELECTED_CHAT_HISTORY: "SET_SELECTED_CHAT_HISTORY",
    SET_CHAT_OWNER: "SET_CHAT_OWNER",
    SET_CLOSED_CHAT: "SET_CLOSED_CHAT",
    UPDATE_CUSTOMER_INFO: "UPDATE_CUSTOMER_INFO",
    SET_LIKED_ANSWER: "SET_LIKED_ANSWER",
    SET_NEW_CHAT_NOTIFICATION: "SET_NEW_CHAT_NOTIFICATION",
    SET_CHAT_OWNER_BUTTON: "SET_CHAT_OWNER_BUTTON",
    SET_CURRENT_CHAT_OPTION: "SET_CURRENT_CHAT_OPTION",
    SET_WORKSPACE_CONFIG: "SET_WORKSPACE_CONFIG",
    SET_CONVERSATION_LABELS: "SET_CONVERSATION_LABELS",
    SET_CONVERSATION_TAG_GROUPS: "SET_CONVERSATION_TAG_GROUPS",
    SET_CHAT_SOCKET_STATUS: "SET_CHAT_SOCKET_STATUS",
    SET_NOTIFICATION_SOCKET_STATUS: "SET_NOTIFICATION_SOCKET_STATUS",
    MARK_READ: "MARK_READ",
    MARK_UNREAD: "MARK_UNREAD",
    SET_WORKSPACE_NAME: "SET_WORKSPACE_NAME",
    SET_AGENT_STATE: "SET_AGENT_STATE",
    SET_NO_DEEP_LINK_CHAT: "SET_NO_DEEP_LINK_CHAT",
};
export default constants;
